// guards
const isObj = (o) => typeof o === 'object' && o !== null;
export const isTransportError = (e, id) => isObj(e) && 'error' in e && (!id || ('requestId' in e && e.requestId === id));
export const isTransportData = (t) => isTransportMessage(t) || isTransportStream(t);
export const isTransportEvent = (t, id) => isObj(t) &&
    'requestId' in t &&
    typeof t.requestId === 'string' &&
    (id ? t.requestId === id : true);
export const isTransportMessage = (m, id) => isTransportEvent(m, id) && 'message' in m;
export const isTransportStream = (s, id) => isTransportEvent(s, id) && 'stream' in s && s.stream instanceof ReadableStream;
export const isTransportAbort = (a, id) => isTransportEvent(a, id) && 'abort' in a && a.abort === true;
